interface ServiceSelectionProps {
  scrollToLegalization: () => void;
  scrollToOldHousing: () => void;
  scrollToSolar: () => void;
}

export default function ServiceSelection({ scrollToLegalization, scrollToOldHousing, scrollToSolar }: ServiceSelectionProps) {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-[#2C4A3E] text-center mb-16">
          어떤 지원이 필요하신가요?
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          {/* Legalization Card */}
          <div className="bg-gradient-to-br from-[#FFF4E6] to-[#FFE8CC] rounded-3xl p-10 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 flex items-center justify-center">
                <i className="ri-building-line text-6xl text-[#5C4033]"></i>
              </div>
            </div>
            <h3 className="text-3xl font-extrabold text-[#5C4033] text-center mb-4">
              불법건축물 양성화
            </h3>
            <p className="text-gray-600 text-center mb-8 text-sm">
              옥탑방, 베란다 확장, 근생빌라 등
            </p>
            <button
              onClick={scrollToLegalization}
              className="w-full border-2 border-[#5C4033] text-[#5C4033] py-3 rounded-full font-semibold hover:bg-[#5C4033] hover:text-white transition-all duration-300 whitespace-nowrap"
            >
              양성화 신청하기
            </button>
          </div>

          {/* Old Housing Card */}
          <div className="bg-gradient-to-br from-[#E8F5E9] to-[#C8E6C9] rounded-3xl p-10 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 flex items-center justify-center">
                <i className="ri-home-gear-line text-6xl text-[#2C4A3E]"></i>
              </div>
            </div>
            <h3 className="text-3xl font-extrabold text-[#2C4A3E] text-center mb-4">
              15년 이상 노후주택 지원
            </h3>
            <p className="text-gray-600 text-center mb-8 text-sm">
              안전진단, 보조금, 개선사업
            </p>
            <button
              onClick={scrollToOldHousing}
              className="w-full border-2 border-[#2C4A3E] text-[#2C4A3E] py-3 rounded-full font-semibold hover:bg-[#2C4A3E] hover:text-white transition-all duration-300 whitespace-nowrap"
            >
              지원사업 신청하기
            </button>
          </div>

          {/* Solar Panel Card */}
          <div className="bg-gradient-to-br from-[#FFF9E6] to-[#FFF3CC] rounded-3xl p-10 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group">
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 flex items-center justify-center">
                <i className="ri-sun-line text-6xl text-[#D97706]"></i>
              </div>
            </div>
            <h3 className="text-3xl font-extrabold text-[#D97706] text-center mb-4">
              옥상에 태양광설치
            </h3>
            <p className="text-gray-600 text-center mb-8 text-sm">
              친환경 에너지, 전기료 절감
            </p>
            <button
              onClick={scrollToSolar}
              className="w-full border-2 border-[#D97706] text-[#D97706] py-3 rounded-full font-semibold hover:bg-[#D97706] hover:text-white transition-all duration-300 whitespace-nowrap"
            >
              태양광 신청하기
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
